const autoNgTemplateLoaderTemplate1 = require('./registryAccess.html');

angular.module('shbdeployer.docker').component('dockerRegistryAccessView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'DockerRegistryAccessController',
  bindings: {
    endpoint: '<',
  },
});
